module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/bg_nagai01-c2a7c3419fc11adc680d762e98c8e525.jpg";